import axios from './axios';

/**
 * Get all translation configs
 */
export const loadTranslationConfigs = async () => {
  const response = await axios.get('translation-configs/');
  return response.data.configs || [];
};

/**
 * Create translation config
 */
export const createConfig = async (data) => {
  const response = await axios.post('translation-configs/create/', data);
  return response.data;
};

/**
 * Update translation config
 */
export const updateConfig = async (id, data) => {
  const response = await axios.put(`translation-configs/${id}/update/`, data);
  return response.data;
};

/**
 * Delete translation config
 */
export const deleteConfig = async (id) => {
  const response = await axios.delete(`translation-configs/${id}/delete/`);
  return response.data;
};

/**
 * Translation configuration API service
 */
export const translationApi = {
  getConfigs: loadTranslationConfigs,
  createConfig,
  updateConfig,
  deleteConfig
};

export default translationApi;
